<template>
    <div class="tab-clinic-location">
        <div class="blockcont">
            <div class="row">
                <div class="col-xs-6">
                    <div class="smalltitle">Assigned Clinic Locations</div>
                </div>
                <div class="col-xs-6 text-right"></div>
                <div class="col-xs-12">
                    <div class="">Those are clinic locations assigned to you by Allergy Immunology Clinic
                        account user. In order for patients to make an appointment to see you, you must
                        associate with an Allergy Immunology Clinic.
                    </div>
                </div>
            </div>
            <ul class="itemlist" v-for="item in clinicDataAdded">
                <li>
                    <div class="row">
                        <div class="col-xs-5"><strong class="address">{{item.name}}</strong><br>
                            <em>{{item.streetNumber}} {{item.streetName}} #{{item.suite}}, {{item.city}},
                                {{item.state}}</em>
                        </div>
                        <div class="col-xs-3">

                        </div>
                        <div class="col-xs-2" style="text-align: right">
                            <span style="display: inline-block;" class="phone">{{item.phone}}</span>
                        </div>
                        <div class="col-xs-2 itemaction">

                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import config from '../../../../config'
import httpClient from '../../../../client'

export default {
  name: 'TabClinicLocation',
  components: {},
  props: {
    userInfo: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      clinicDataAdded: []
    }
  },
  computed: {
    disabledForm () {
      return true
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    this.getClinicLocation()
  },
  beforeDestroy () {
  },
  methods: {
    async getClinicLocation () {
      try {
        let response = await httpClient.get('/users/clinic-location-of-doctor/' + this.userInfo.id)
        if (response.data.s === 200) {
          this.clinicDataAdded = response.data.data.clinicLocations
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
